<template>
  <div class="wlx-site-manager-wrapper">
      <header class="site-manager-head-con">
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input v-model="sTitle" placeholder="请输入教材标题" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-circle-plus-outline" @click="add">添加</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-delete" @click="deleteAll">删除</el-button>
          </el-form-item>
        </el-form>
      </header>
      <!-- 新增资料 -->
      <el-dialog
        title="新增资料"
        :visible.sync="addNewNoticeVisible"
        :before-close="cancel"
        width="50%"
        :append-to-body="true"
        :close-on-click-modal="false">
        <div>
          <el-form ref="ruleForm" label-width="80px">
            <el-form-item label="标题" prop="title">
              <el-input v-model="title"></el-input>
            </el-form-item>
            <el-form-item label="作者" prop="title">
              <el-input v-model="autor"></el-input>
            </el-form-item>
            <el-form-item label="发布时间" prop="PublishTime">
              <!-- <el-input v-model="PublishTime"></el-input> -->
              <el-date-picker
                v-model="PublishTime"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="ISBN" prop="ISBN">
              <el-input v-model="ISBN"></el-input>
            </el-form-item>
            <el-form-item label="链接" prop="Url">
              <el-input v-model="Url"></el-input>
            </el-form-item>
            <el-form-item label="出版社" prop="Press">
              <el-input v-model="Press"></el-input>
            </el-form-item>
            <el-form-item label="页数" prop="PageTotal">
              <el-input v-model="PageTotal"></el-input>
            </el-form-item>
            <el-form-item label="适用对象" prop="title">
              <el-input v-model="suitable"></el-input>
            </el-form-item>
            <el-form-item label="类型" style="width: 100%;">
              <el-radio-group v-model="levelType">
                <el-radio :label="1">初级物流师资料</el-radio>
                <el-radio :label="2">中级物流师资料</el-radio>
                <el-radio :label="3">高级物流师资料</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="资料介绍">
              <textarea v-model="description" style="width:100%;height:100px;"></textarea>
            </el-form-item>
            <el-form-item label="作者介绍">
              <textarea v-model="AutorDescription" style="width:100%;height:100px;"></textarea>
            </el-form-item>
            <el-form-item label="目录概要">
              <textarea v-model="Catalogue" style="width:100%;height:100px;"></textarea>
            </el-form-item>
            <el-form-item label="logo：">
              <imageUpload :url="urlAliyunOSS" :files.sync="cover" format="image"></imageUpload>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="addLearningMaterial()">确 定</el-button>
        </span>
      </el-dialog>
      <!--编辑-->
      <el-dialog
        title="编辑资料"
        :visible.sync="editNoticeVisible"
        :before-close="cancel"
        width="50%"
        :append-to-body="true"
        :close-on-click-modal="false">
        <div>
          <el-form ref="ruleForm" label-width="80px">
            <el-form-item label="标题" prop="title">
              <el-input v-model="title"></el-input>
            </el-form-item>
            <el-form-item label="作者" prop="title">
              <el-input v-model="autor"></el-input>
            </el-form-item>
            <el-form-item label="发布时间" prop="PublishTime">
              <!-- <el-input v-model="PublishTime"></el-input> -->
              <el-date-picker
                v-model="PublishTime"
                type="datetime"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="ISBN" prop="ISBN">
              <el-input v-model="ISBN"></el-input>
            </el-form-item>
            <el-form-item label="链接" prop="Url">
              <el-input v-model="Url"></el-input>
            </el-form-item>
            <el-form-item label="出版社" prop="Press">
              <el-input v-model="Press"></el-input>
            </el-form-item>
            <el-form-item label="页数" prop="PageTotal">
              <el-input v-model="PageTotal"></el-input>
            </el-form-item>
            <el-form-item label="适用对象" prop="title">
              <el-input v-model="suitable"></el-input>
            </el-form-item>
            <el-form-item label="类型" style="width: 100%;">
              <el-radio-group v-model="levelType">
                <el-radio :label="1">初级物流师资料</el-radio>
                <el-radio :label="2">中级物流师资料</el-radio>
                <el-radio :label="3">高级物流师资料</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="资料介绍">
              <textarea v-model="description" style="width:100%;height:100px;"></textarea>
            </el-form-item>
            <el-form-item label="作者介绍">
              <textarea v-model="AutorDescription" style="width:100%;height:100px;"></textarea>
            </el-form-item>
            <el-form-item label="目录概要">
              <textarea v-model="Catalogue" style="width:100%;height:100px;"></textarea>
            </el-form-item>
            <el-form-item label="logo：">
              <imageUpload :url="urlAliyunOSS" :files.sync="cover" format="image"></imageUpload>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="addLearningMaterial()">确 定</el-button>
        </span>
      </el-dialog>
     

      <el-table
        ref="multipleeeeTable"
        :data="list"
        tooltip-effect="dark"
        empty-text=" "
        style="width: 100%;"
        @selection-change="handleSelectionChange">
        <el-table-column prop="id" type="selection" width="55"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column prop="title" label="标题" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="autor" label="作者" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createUserName" label="上传者" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
        <el-table-column prop="levelType" label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.levelType==1">初级物流师资料</span>
            <span v-if="scope.row.levelType==2">中级物流师资料</span>
            <span v-if="scope.row.levelType==3">高级物流师资料</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="el-icon-view"
              @click="upload(scope.row.id)"
              type="primary"
              title="上传"
            ></el-button>
            <el-button
              size="mini"
              class="el-icon-edit"
              @click="edit(scope.row)"
              type="primary"
              title="编辑"
            ></el-button>
            <el-button
              size="mini"
              type="danger"
              class="el-icon-delete"
              @click="deleteMajor(scope.row.id)"
              titlt="删除"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="u-page-con">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="pageIndex"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          v-show="total>0">
        </el-pagination>
      </div>
  </div>
</template>

<script>
import imageUpload from "components/imageUpload.vue";
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      pageIndex: 1,
      addNewNoticeVisible: false,
      editNoticeVisible: false,
      /* -----------添加/修改弹框参数------------ */
      sTitle: "",
      title: "",
      cover: "",
      autor: "",
      suitable: "",
      description: "",
      levelType: 1,
      AutorDescription:'',
      PublishTime:'',
      ISBN:'',
      Url:'',
      Press:'',
      PageTotal:'',
      Catalogue:'',
      urlAliyunOSS: "/api/design/osssign/getsign",
      teachingMaterialId: "",
      /* --------------------------------------- */
      id: "",
      TeachingMaterialIds: [],
      noDataShow: false,
      loadingShow: false
    };
  },
  components: {
    imageUpload
  },
  created() {
    this.getLearningMaterialList();
  },
  methods: {
    getLearningMaterialList(page) {
      var that = this;
      this.$http.post("/api/XOrg/LearningMaterialManager/getLearningMaterialList", {
          title: this.sTitle,
          page: page,
          pageSize: this.pageSize
        }).then(rst => {
          if (rst.code == 1) {
            that.list = rst.list;
            that.total = rst.pagination.totalCount;
            that.pageSize = rst.pagination.pageSize;
            that.pageIndex = rst.pagination.pageIndex;
            that.cancel();
          }
        });
    },
    onPageChangeHandler(page) {
      this.getLearningMaterialList(page);
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getLearningMaterialList(1);
    },
    handleSelectionChange(val) {
      this.TeachingMaterialIds = [];
      val.forEach(element => {
        this.TeachingMaterialIds.push(element.id);
      });
    },
    cancel() {
      (this.addNewNoticeVisible = false),
        (this.editNoticeVisible = false),
        (this.title = ""),
        (this.cover = ""),
        (this.autor = ""),
        (this.suitable = ""),
        (this.description = ""),
        (this.AutorDescription = ""),
        (this.PublishTime = ""),
        (this.ISBN = ""),
        (this.Url = ""),
        (this.Press = ""),
        (this.PageTotal = ""),
        (this.Catalogue = ""),
        (this.levelType = 1),
        (this.TeachingMaterialIds = []);
      this.teachingMaterialId = "";
    },
    addLearningMaterial() {
      var that = this;
      this.$http
        .post("/api/XOrg/LearningMaterialManager/AddOrEditLearningMaterial", {
          materialId: that.teachingMaterialId,
          Title: that.title,
          cover: that.cover,
          autor: that.autor,
          suitable: that.suitable,
          description: that.description,
          levelType: that.levelType,
          AutorDescription:that.AutorDescription,
          PublishTime: that.PublishTime,
          ISBN: that.ISBN,
          Url: that.Url,
          Press: that.Press,
          PageTotal: that.PageTotal,
          Catalogue: that.Catalogue,
        })
        .then(rst => {
          if (rst.code == 1) {
            that.cancel();
            that.$message({
              showClose: true,
              message: rst.msg,
              type: "success"
            });
            that.teachingMaterialId = "";
            that.getLearningMaterialList();
          }
        });
    },
    add() {
      this.addNewNoticeVisible = true;
    },
    edit(row) {
      this.editNoticeVisible = true;
      this.title = row.title;
      this.cover = row.cover;
      this.autor = row.autor;
      this.suitable = row.suitable;
      this.description = row.description;
      this.teachingMaterialId = row.id;
      this.orderNumber = row.orderNumber;
      this.levelType = row.levelType;
      this.AutorDescription = row.AutorDescription;
      this.PublishTime = row.PublishTime;
      this.ISBN = row.ISBN;
      this.Url = row.Url;
      this.Press = row.Press;
      this.PageTotal = row.PageTotal;
      this.Catalogue = row.Catalogue;
    },
    deleteMajor(id) {
      this.TeachingMaterialIds.push(id);
      this.$confirm("此操作将删除该资料, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    search() {
      this.getLearningMaterialList(1);
    },
    deleteAll() {
      if (this.TeachingMaterialIds.length === 0) {
        this.$message({
          showClose: true,
          message: "请选择教材",
          type: "warning"
        });
        return false;
      }
      this.$confirm("此操作将删除所选资料, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFun();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    deleteFun() {
      var that = this;
      this.$http
        .post("/api/XOrg/LearningMaterialManager/DeleteLearningMaterial", {
          teachingMaterialIds: this.TeachingMaterialIds
        })
        .then(rst => {
          if (rst.code == 1) {
            that.$message.success(rst.msg);
            that.getLearningMaterialList();
          } else {
            that.$message.warning(rst.msg);
          }
        });
    },
    upload(id){
      this.$router.push({
        name: 'stuUpload',
        params:{
          learnId: id
        }
      })
    }
  }
};
</script>
